import { createSlice } from "@reduxjs/toolkit";
import dayjs from 'dayjs';

const calendarSlice = createSlice({
    name: 'calendar',
    initialState: {
        selectedDate: dayjs().format('YYYY-MM-DD'),
 },
    reducers: {
        setSelectedDate: (state, action: { payload: string }) => {
            state.selectedDate = action.payload
        },
    }
})

export const { setSelectedDate } = calendarSlice.actions;

export default calendarSlice.reducer;

export const selectSelectedDate = (state: { calendar: { selectedDate: string } }) => state.calendar.selectedDate